module.exports = __webpack_public_path__ + "img/02.de162596.png";